import { NotFoundContainer } from 'components/notFoundContainer'
import { ReactNode } from 'react'

import { Container, Spinner } from './LoadingContainer.styled'

export interface LoadingContainerProps {
    isLoading: boolean
    error: Error | null | undefined
    children: ReactNode
    hideError?: boolean
}

export const LoadingContainer = ({ isLoading, error, children }: LoadingContainerProps) => {
    let content: ReactNode

    if (isLoading) {
        content = (
            <Container>
                <Spinner />
            </Container>
        )
    } else if (error) {
        console.log(error)
        content = (
            <Container>
                <NotFoundContainer />
            </Container>
        )
    } else {
        content = children
    }

    return <>{content}</>
}
